import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

export const groupIdRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct group ID'),
    min: 0,
    max: 15,
  });
};
